import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import {ContextProvider} from '../../components/ContextProvider/ContextProvider';
import {getFeedbackConfig, getMealFeedback, setFeedbackConfig, setMealFeedback} from '../../actions/feedback.action';
import {
  ContentWrapper,
  Title,
  Subtitle,
  Form,
  Block,
  LoadingWrapper,
  ContentTitle,
  Question,
  Answer,
  AnswerText,
  Yes,
  No,
  GreenDot,
  RedDot,
  CommentsWrapper,
  Comments,
  MealBlock,
  MealName,
  Submit
} from './Feedback.style';
import {FeedbackRating} from './FeedbackRating';
import Loading from '../../components/Loading/Loading';
import InfoModal from '../../components/Modal/InfoModal';
import {FEEDBACK_FULFILLMENT_ERROR} from '../../constants/modalType';
import {FEEDBACK_STATUS} from '../../constants/constant';

export class Feedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      config: null,
      feedback: [],
      overallComment: '',
      modalType: null
    };
    this.setOnTime = this.setOnTime.bind(this);
    this.setNotOnTime = this.setNotOnTime.bind(this);
    this.setFeedbackForEachItem = this.setFeedbackForEachItem.bind(this);
    this.updateOverallComment = this.updateOverallComment.bind(this);
    this.overallCommentOnBlur = this.overallCommentOnBlur.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  componentWillMount() {
    const {getFeedbackConfigFunc, getMealFeedbackFunc, match, restaurantCode} = this.props;
    const {orderId, feedbackId} = match.params;
    const actualFeedbackId = feedbackId.split('&')[0];
    getFeedbackConfigFunc(restaurantCode, orderId, actualFeedbackId)
      .then(config => this.setState(
        {
          config,
          overallComment: config.comment
        }
      ));
    getMealFeedbackFunc(restaurantCode, orderId, actualFeedbackId)
      .then(feedback => this.setState({feedback}));
  }

  setFeedbackForEachItem(item, pos) {
    const {match, setMealFeedbackFunc} = this.props;
    const {feedbackId} = match.params;
    const actualFeedbackId = feedbackId.split('&')[0];
    setMealFeedbackFunc(actualFeedbackId, item)
    .then(updated => {
        const {feedback} = this.state;
        const newFeedback = [
          ...feedback.slice(0, pos),
          updated,
          ...feedback.slice(pos + 1)
        ];
        this.setState({feedback: newFeedback});
      });
  }

  updateOverallComment(e) {
    this.setState({overallComment: e.target.value});
  }

  updateFeedbackConfig(updatedField) {
    const updated = Object.assign({}, this.state.config, updatedField);
    this.props.setFeedbackConfigFunc(updated)
      .then(config => this.setState({config}));
  }

  setOnTime() {
    this.updateFeedbackConfig({deliveredOnTime: 'true'});
  }

  setNotOnTime() {
    this.updateFeedbackConfig({deliveredOnTime: 'false'});
  }

  overallCommentOnBlur() {
    this.updateFeedbackConfig({comment: this.state.overallComment});
  }

  submitForm() {
    const {config} = this.state;
    if (!config) {
      return;
    }
    if (typeof config.deliveredOnTime === 'undefined') {
      this.setState({modalType: FEEDBACK_FULFILLMENT_ERROR});
      return;
    }
    this.updateFeedbackConfig({status: FEEDBACK_STATUS.COMPLETED});
  }

  handleCloseModal() {
    this.setState({modalType: null});
  }
  render() {
    const {restaurant} = this.props;
    const {config, feedback} = this.state;
    if (config && (config.status === FEEDBACK_STATUS.COMPLETED || config.status === FEEDBACK_STATUS.AUTO_CLOSED)) {
      return (
        <ContentWrapper>
          <Title>
            <FormattedMessage id="feedback.thanks" />
          </Title>
        </ContentWrapper>
      );
    }
    const getFulfillmentType = config && config.fulfillmentMethod === 'COLLECTION'
      ? 'feedback.order.collection'
      : 'feedback.order.delivery';
    const renderTheService = config ? (
      <Block>
        <ContentTitle>The service</ContentTitle>
        <Question>
          <FormattedMessage
            id={getFulfillmentType}
            values={{minEta: config.originalMinEta, maxEta: config.originalMaxEta}}
          />
        </Question>
        <Answer>
          <Yes
            selected={config.deliveredOnTime === true}
            onClick={this.setOnTime}
          >
            <GreenDot selected={config.deliveredOnTime === true} />
            <AnswerText>Yes</AnswerText>
          </Yes>
          <No
            selected={config.deliveredOnTime === false}
            onClick={this.setNotOnTime}
          >
            <RedDot selected={config.deliveredOnTime === false} />
            <AnswerText>No</AnswerText>
          </No>
        </Answer>
        <Question>
          <FormattedMessage id="feedback.comments" />
        </Question>
        <CommentsWrapper>
          <Comments
            placeholder="Share your thoughts about the service"
            value={this.state.overallComment}
            onChange={this.updateOverallComment}
            onBlur={this.overallCommentOnBlur}
          />
        </CommentsWrapper>
      </Block>
    ) : (
      <LoadingWrapper>
        <Loading isLight={true} />
      </LoadingWrapper>
    );
    const renderFeedback = feedback && feedback.map((value, pos) => (
      <MealBlock key={value.mealLibraryId}>
        <MealName>{value.mealName}</MealName>
        <Block>
          <Question>
            <FormattedMessage id="feedback.orderAgain" />
          </Question>
        </Block>
        <FeedbackRating
          feedback={value}
          setMealFeedback={this.setFeedbackForEachItem}
          pos={pos}
        />
      </MealBlock>
      )
    );
    const renderFeedbackForm = feedback && (
      <div>
        <ContentTitle>Your order</ContentTitle>
        {renderFeedback}
      </div>
    );
    const renderModal = this.state.modalType === FEEDBACK_FULFILLMENT_ERROR &&
      InfoModal({
        type: this.state.modalType,
        closeModalCallback: this.handleCloseModal
      });
    return (
      <ContentWrapper>
        <Title>
          <FormattedMessage
            id="feedback.title"
            values={{name: restaurant.name}}
          />
        </Title>
        <Subtitle>
          <FormattedMessage id="feedback.subtitle" />
          </Subtitle>
        <Form>
          {renderTheService}
          {renderFeedbackForm}
        </Form>
        <Submit
          greyed={!config || !feedback.length}
          onClick={this.submitForm}
        >
          Submit
        </Submit>
        {renderModal}
      </ContentWrapper>
    );
  }
}

Feedback.propTypes = {
  restaurant: PropTypes.object.isRequired,
  getFeedbackConfigFunc: PropTypes.func,
  getMealFeedbackFunc: PropTypes.func,
  setFeedbackConfigFunc: PropTypes.func,
  setMealFeedbackFunc: PropTypes.func,
  restaurantCode: PropTypes.string,
  match: PropTypes.object
};

const mapStateToProps = state => {
  return {
    restaurantCode: state.restaurantCode
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getFeedbackConfigFunc: bindActionCreators(getFeedbackConfig, dispatch),
    getMealFeedbackFunc: bindActionCreators(getMealFeedback, dispatch),
    setFeedbackConfigFunc: bindActionCreators(setFeedbackConfig, dispatch),
    setMealFeedbackFunc: bindActionCreators(setMealFeedback, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContextProvider(Feedback));



// WEBPACK FOOTER //
// ./containers/FeedbackPage/Feedback.js